import { useEffect } from 'react'
import { useIntercom } from 'react-use-intercom'
import {
  getCurrentIntercomBootOptions,
  requestDefaultLauncherVisibility,
} from './intercomLauncherVisibility'

const syncDefaultLauncherVisibility = update => {
  update(getCurrentIntercomBootOptions())
}

/**
 * Opt-in to Intercom's default floating launcher while mounted.
 * Default app policy keeps the launcher hidden; call with shouldShow=true
 * from a page, shell, or modal that should show the native bubble.
 */
const useDefaultLauncherVisibility = (shouldShow = true) => {
  const { update } = useIntercom()

  useEffect(() => {
    if (!shouldShow) {
      syncDefaultLauncherVisibility(update)
      return undefined
    }

    const releaseDefaultLauncherVisibility = requestDefaultLauncherVisibility()
    syncDefaultLauncherVisibility(update)

    return () => {
      releaseDefaultLauncherVisibility()
      syncDefaultLauncherVisibility(update)
    }
  }, [shouldShow, update])
}

export default useDefaultLauncherVisibility
